import Button from "components/buttons/Button"
import useTranslations from "hooks/useTranslations"

/**
 * The UK SomeBuddy app. Not the menu's own "Log in" (GATSBY_TOOSA_URL,
 * app.somebuddy.com), which currently lands on the Swedish login; parents
 * here sign in with their child's UK school access.
 */
export const LOGIN_URL = "https://somebuddy.help"

/**
 * Shown in the hero and after the "use SomeBuddy together" steps while we
 * compare which reads best; drop the one that doesn't earn its place. Fixed width because Button stretches to fill its
 * container. Always dark, for the mint grounds it sits on.
 * Takes no props, so the hero's own bgStyle hint is ignored.
 */
export default function LoginButton() {
  const { buttonLogin } = useTranslations()

  return (
    <div className="w-40">
      <Button
        bgStyle="black"
        label={buttonLogin}
        link={LOGIN_URL}
        outbound
        target="_blank"
      />
    </div>
  )
}
